import React from 'react';
import { FcTodoList } from 'react-icons/fc';
import Card from './Card';

function SerialRegisterCard(props) {
    return (
        <Card clickCardHandler={props.clickCardHandler} title="ثبت سریال محصولات" icon={FcTodoList}>
        </Card>
    );
}
export default SerialRegisterCard;